import type { PaidStore } from './interfaces'

const setAvailableSlots = (state: PaidStore, payload: PaidStore['availableSlots']): void => {
  state.availableSlots = payload
}

const setBookingDate = (state: PaidStore, payload: PaidStore['bookingDate']): void => {
  state.bookingDate = payload
}

export const actions = {
  setChangeTutorModal (this: PaidStore, open: boolean) {
    this.isChangeTutorModalOpen = open
  },
  setChangeTutorSuccessModal (this: PaidStore, open: boolean) {
    this.isChangeTutorSuccessModalOpen = open
  },
  setLoading (this: PaidStore, payload: PaidStore['loading']): void {
    this.loading = payload
  },
  setProcessing (this: PaidStore, payload: PaidStore['processing']): void {
    this.processing = payload
  },
  setModalReschedule (this: PaidStore, payload: PaidStore['modalReschedule']): void {
    this.modalReschedule = payload
  },
  setModalFirstLessonAttend (this: PaidStore, payload: PaidStore['modalFirstLessonAttend']): void {
    this.modalFirstLessonAttend = payload
  },
  setFirstLessonAttendPending (this: PaidStore, payload: PaidStore['firstLessonAttendPending']): void {
    this.firstLessonAttendPending = payload
  },
  setModalCancel (this: PaidStore, payload: PaidStore['modalCancel']): void {
    this.modalCancel = payload
  },
  setRescheduleDate (this: PaidStore, payload: PaidStore['rescheduleDate']): void {
    this.rescheduleDate = payload
  },
  setRescheduleTime (this: PaidStore, payload: PaidStore['rescheduleTime']): void {
    this.rescheduleTime = payload
  },
  setAvailableSlots (this: PaidStore, payload: PaidStore['availableSlots']): void {
    return setAvailableSlots(this, payload)
  },
  setBookingDate (this: PaidStore, payload: PaidStore['bookingDate']): void {
    return setBookingDate(this, payload)
  },
  setTriggerRescheduleSelect (this: PaidStore): void {
    this.triggerRescheduleSelect++
  },
  setAllLessonsSwitcher (this: PaidStore, payload: PaidStore['allLessonsSwitcher']): void {
    this.allLessonsSwitcher = payload
  },
  setModalUpsell (this: PaidStore, payload: PaidStore['modalUpsell']): void {
    this.modalUpsell = payload
  },
}
